/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/hello": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["AppController_getHello"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/playlists/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["PlaylistsAdminController_dropTestData"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/playlists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["PlaylistsAdminController_getAll"];
        put?: never;
        post: operations["PlaylistsAdminController_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/playlists/add-days": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["PlaylistsAdminController_addDays"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/playlists/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["PlaylistsAdminController_getById"];
        put: operations["PlaylistsAdminController_update"];
        post?: never;
        delete: operations["PlaylistsAdminController_del"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/playlists/{id}/image": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Upload or replace playlist cover image */
        put: operations["PlaylistsAdminController_upsertImage"];
        post?: never;
        /** Remove playlist cover image */
        delete: operations["PlaylistsAdminController_deleteImage"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/student/playlists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["PlaylistsStudentController_getPlaylists"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/student/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["PlaylistsStudentController_getVideos"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/student/{id}/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["PlaylistsStudentController_getVideosForPlaylist"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/friend/video": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["FriendController_video"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/friend/playlist/{playlistId}/courseIds": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["FriendController_getPlaylistCourseIds"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/friend/not-viewed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["FriendController_notViewed"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/playlists/{idOrSlug}/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get videos by playlist id or playlist slug */
        get: operations["PlaylistsPublicController_getPublicVideosByPlaylistId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/playlists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description get playlists by courseId with video count and pagination and sorting */
        get: operations["PlaylistsPublicController_getPublicPlaylists"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["VideosAdminController_dropTestData"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["VideosAdminController_getAll"];
        put?: never;
        post: operations["VideosAdminController_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/by-playlist-id/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: operations["VideosAdminController_getByPlaylist"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/add-days": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: operations["VideosAdminController_addDays"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["VideosAdminController_getById"];
        put: operations["VideosAdminController_update"];
        post?: never;
        delete: operations["VideosAdminController_del"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/{id}/images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Replace video images from hosting
         * @description Downloads thumbnails from the hosting (e.g. YouTube), uploads them to internal storage, removes previous images from storage, and replaces VideoImage records for the given video. Pass optional `locale` query param to sync only a specific locale.
         */
        put: operations["VideosAdminController_replaceImages"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/sort-all/{x}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["VideosAdminController_sortAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/sort/{pl}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["VideosAdminController_sort"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/order/{playlistId}/{videoId}/{order}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @deprecated */
        get: operations["VideosAdminController_order"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/order": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["VideosAdminController_orderNew"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get recent videos from public courses */
        get: operations["VideosPublicController_getRecentVideos"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/{idOrSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["VideosPublicController_getVideo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/friend/videos/{videoSlug}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["FriendVideoController_getVideo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/migrate-hostings/{key}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Migrate legacy hosting fields to VideoHosting table
         * @deprecated
         */
        get: operations["MigrateHostingsController_migrateHostings"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/migrate-locales/{key}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Migrate legacy text fields to VideoLocale table
         * @deprecated
         */
        get: operations["MigrateHostingsController_migrateLocales"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/reactions/{videoId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["ReactionsController_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/{videoId}/reactions/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Remove user reaction from a video
         * @description Deletes the current user reaction of the specified type for the given video. The operation is idempotent. Returns 204 on success.
         */
        delete: operations["VideoReactionsController_removeReaction"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/comments/{commentId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["CommentsController_del"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/comments/{commentId}/likes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CommentsController_addLike"];
        delete: operations["CommentsController_deleteLike"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["AdminCommentsController_getAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/comments/fix": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["AdminCommentsController_fix"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/comments/{commentId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: operations["AdminCommentsController_del"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/{idOrSlugVideo}/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["CommentsVideoController_getByVideo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/{videoIdOrSlug}/comments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CommentsVideoController_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/videos/{videoId}/views": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Mark the given video as viewed by the current public user */
        post: operations["ViewController_add"];
        /** Remove viewed mark for the given video (idempotent) */
        delete: operations["ViewController_delete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/view": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @deprecated */
        post: operations["DeprecatedViewController_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/mdx-files/tree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get mdx files tree */
        get: operations["MdxFilesAdminController_getMdxFilesTree"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/mdx-files/{mdxpath}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get mdx content */
        get: operations["MdxFilesAdminController_getMdxFile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/{videoId}/mdx-notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add mdx content for video. For PREVIEW publicVisibility always is PUBLIC. For MAIN publicVisibility should be set */
        post: operations["MdxNotesAdminController_addMdxNoteForVideo"];
        /** delete note */
        delete: operations["MdxNotesAdminController_deleteMdxNoteById"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/{videoId}/mdx-notes/main": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Update MAIN video note */
        put: operations["MdxNotesAdminController_updateMdxNoteForVideo"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/videos/{videoId}/mdx-notes/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Update PREVIEW video note */
        put: operations["MdxNotesAdminController_updateMdxNotePreviewForVideo"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/mdx-notes/{noteId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get mdx content by id */
        get: operations["MdxNotesPublicController_getVideoMdxNoteFile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/friend/users/{userId}/views/by-course": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["FriendUserStatisticController_getViewsByCourse"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/metrics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["DynamicMetricsController_getMetrics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/casbin/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["CasbinController_generateActions"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["HealthController_healthCheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        PlaylistSettingsOutputModel: {
            id: string;
            courseId: number;
            plType: string;
            accessLevel: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
        };
        ImageDto: {
            type: Record<string, never>;
            width: number;
            height: number;
            fileSize: number;
            url: string;
        };
        PlaylistOutputModel: {
            id: string;
            name: string;
            settings: components["schemas"]["PlaylistSettingsOutputModel"][];
            images: components["schemas"]["ImageDto"][];
            slug: string | null;
            description: string | null;
            seoDescription: string | null;
        };
        AdminInfoDto: {
            name: string;
            id: number;
            role: string;
        };
        PlaylistsOutputModel: {
            playlists: components["schemas"]["PlaylistOutputModel"][];
            totalCount: number;
            admin?: components["schemas"]["AdminInfoDto"];
        };
        PlaylistSettingsInputModel: {
            courseId: number;
            plType: string;
            accessLevel: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
        };
        PlaylistInputModel: {
            name: string;
            settings: components["schemas"]["PlaylistSettingsInputModel"][];
            /** @description slug should not be cuid */
            slug?: string;
            description?: string;
            seoDescription?: string;
        };
        CreateResponseCommonDto: {
            data: {
                id?: string;
            };
        };
        SettingsAddDaysInputModel: {
            /** @description default: 730 // 2 years */
            days?: number;
            settingIds: string[];
        };
        PlaylistSettingsUpdateModel: {
            id: string;
            courseId: number;
            plType: string;
            accessLevel: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
        };
        PlaylistUpdateModel: {
            name?: string;
            settings?: components["schemas"]["PlaylistSettingsUpdateModel"][];
            /** @description slug should not be cuid */
            slug?: string;
            description?: string;
            seoDescription?: string;
        };
        VideoForStudentInPlaylistModel: {
            id: string;
            name: string;
            playlistId: string;
            forLesson: number;
            accessLevel: number;
            tags: string[];
            viewed: boolean;
        };
        PlaylistForStudentModel: {
            id: string;
            name: string;
            videos: components["schemas"]["VideoForStudentInPlaylistModel"][];
            percent: number;
            description: string | null;
            slug: string | null;
        };
        PlaylistsForStudentModel: {
            playlists: components["schemas"]["PlaylistForStudentModel"][];
        };
        VideoSettingsOutputModel: {
            id: string;
            playlistId: string;
            courseId: number;
            accessLevel: number;
            forLesson: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
        };
        TagOutputModel: {
            id: string;
            text: string;
        };
        ReactionOutputModel: {
            id: string;
            reaction: string;
        };
        VideoOutputModel: {
            id?: string;
            name?: string;
            description?: string;
            hosting?: string;
            hostingId?: string;
            hostingHash?: string;
            code?: string;
            mentor?: string;
            mentorId?: number;
            startDate?: string;
            superContentCount: number;
            firePresentationCount: number;
            normalCount: number;
            hardUnderstandingCount: number;
            improvedUnderstandingCount: number;
            nothingNewCount: number;
            allUnderstandingCount: number;
            failedPresentationCount: number;
            settings?: components["schemas"]["VideoSettingsOutputModel"][];
            tags?: components["schemas"]["TagOutputModel"][];
            reactions?: components["schemas"]["ReactionOutputModel"][];
            slug: string | null;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            images: components["schemas"]["ImageDto"][];
        };
        VideosOutputModel: {
            videos: components["schemas"]["VideoOutputModel"][];
            totalCount: number;
        };
        /** @enum {string} */
        ImageType: ImageType;
        PlaylistVideoImageResponseDto: {
            /**
             * @description Type of video image (ORIGINAL | MEDIUM | THUMBNAIL)
             * @example ORIGINAL
             */
            type: components["schemas"]["ImageType"];
            width: number;
            height: number;
            fileSize: number;
            url: string;
        };
        GetPlaylistVideosPublicItemResponseDto: {
            /** @description Resolved images for the video (stored in internal storage) */
            images: components["schemas"]["PlaylistVideoImageResponseDto"][];
            id: string;
            name: string;
            mentor: string;
            startDate: string;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            slug: string | null;
            /** Format: date-time */
            updated: string;
            /** @enum {string|null} */
            publicVisibilityErrorStatus: GetPlaylistVideosPublicItemResponseDtoPublicVisibilityErrorStatus;
            /**
             * @description Ограничение по прогрессу (уровень)
             * @enum {string|null}
             */
            availabilityError: GetPlaylistVideosPublicItemResponseDtoAvailabilityError;
            /**
             * @description Indicates whether an item has been viewed or not.
             *     This variable can take a boolean value (`true` if viewed, `false` if not viewed)
             *     or `null` if the viewed status is unknown (for unauthenticated users).
             */
            viewed: boolean | null;
        };
        PlaylistCoverImageResponseDto: {
            /**
             * @description Type of video image (ORIGINAL | MEDIUM | THUMBNAIL)
             * @example ORIGINAL
             */
            type: components["schemas"]["ImageType"];
            width: number;
            height: number;
            fileSize: number;
            url: string;
        };
        GetPlaylistVideosPublicResponseDto: {
            items: components["schemas"]["GetPlaylistVideosPublicItemResponseDto"][];
            /** @description Resolved images for the playlist (stored in internal storage) */
            playlistImages: components["schemas"]["PlaylistCoverImageResponseDto"][];
            playlistId: string;
            playlistName: string;
            playlistDescription: string | null;
            playlistSeoDescription: string | null;
            totalCount: number;
        };
        PlaylistImageResponseDto: {
            /**
             * @description Type of video image (ORIGINAL | MEDIUM | THUMBNAIL)
             * @example ORIGINAL
             */
            type: components["schemas"]["ImageType"];
            width: number;
            height: number;
            fileSize: number;
            url: string;
        };
        GetPlaylistsPublicItemResponseDto: {
            images: components["schemas"]["PlaylistImageResponseDto"][];
            id: string;
            name: string;
            description: string | null;
            slug: string | null;
            videoCount: number;
            /** Format: date-time */
            updated: string;
        };
        GetPlaylistsPublicResponseDto: {
            items: components["schemas"]["GetPlaylistsPublicItemResponseDto"][];
            totalCount: number;
        };
        GetAdminVideoSettingQueryOutput: {
            id: string;
            playlistId: string;
            courseId: number;
            accessLevel: number;
            forLesson: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
            order: number;
        };
        GetAdminVideoTagQueryOutput: {
            id: string;
            text: string;
        };
        GetAdminVideoHostingQueryOutput: {
            /** @enum {string} */
            provider: GetAdminVideoHostingQueryOutputProvider;
            id: string;
            locale: string;
            isPrimary: boolean;
            hostingId: string | null;
            hostingHash: string | null;
            url: string | null;
            metadata: Record<string, never>;
        };
        GetAdminVideoLocaleQueryOutput: {
            id: string;
            locale: string;
            name: string;
            description: string;
            seoDescription: string | null;
        };
        GetAdminVideosQueryItemOutput: {
            id: string;
            name: string;
            description: string;
            slug: string | null;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            hosting: string;
            hostingId: string;
            hostingHash: string;
            code: string;
            mentor: string;
            startDate: string;
            url: string;
            hasMainMdxNote: boolean;
            settings: components["schemas"]["GetAdminVideoSettingQueryOutput"][];
            tags: components["schemas"]["GetAdminVideoTagQueryOutput"][];
            hostings: components["schemas"]["GetAdminVideoHostingQueryOutput"][];
            locales: components["schemas"]["GetAdminVideoLocaleQueryOutput"][];
            order: number;
            seoDescription: string | null;
        };
        GetAdminVideosResponseDto: {
            items: components["schemas"]["GetAdminVideosQueryItemOutput"][];
            totalCount: number;
        };
        CreateVideoSettingsDto: {
            playlistId: string;
            /** @description Deprecated */
            courseId?: number;
            accessLevel: number;
            forLesson: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
        };
        CreateVideoTagDto: {
            text: string;
        };
        CreateVideoHostingDto: {
            provider: Record<string, never>;
            locale: string;
            isPrimary: boolean;
            hostingId?: string;
            hostingHash?: string;
            url?: string;
            metadata?: Record<string, never>;
        };
        CreateVideoLocaleDto: {
            locale: string;
            name: string;
            description?: string;
            seoDescription?: string;
        };
        AddVideoRequestPayload: {
            name: string;
            description?: string;
            hosting: string;
            hostingId: string;
            hostingHash: string;
            code?: string;
            mentor?: string;
            mentorId?: number;
            startDate?: string;
            settings: components["schemas"]["CreateVideoSettingsDto"][];
            tags: components["schemas"]["CreateVideoTagDto"][];
            url?: string;
            /** @enum {string} */
            publicVisibility?: VideoOutputModelPublicVisibility;
            /** @description slug should not be cuid */
            slug?: string;
            seoDescription?: string;
            hostings?: components["schemas"]["CreateVideoHostingDto"][];
            locales?: components["schemas"]["CreateVideoLocaleDto"][];
        };
        CommentForStudentModel: {
            id: string;
            studentId: number;
            text: string;
            /** Format: date-time */
            created: string;
            /** Format: date-time */
            updated: string;
            avatar: string;
            firstName: string;
            lastName: string;
        };
        AdminMdxNoteResponseDto: {
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            /** @enum {string} */
            noteType: PathsApiAdminVideosVideoIdMdxNotesDeleteParametersQueryNoteType;
            id: string;
            mdxFilePath: string;
        };
        AdminVideoOutputModel: {
            id?: string;
            name?: string;
            description?: string;
            hosting?: string;
            hostingId?: string;
            hostingHash?: string;
            code?: string;
            mentor?: string;
            startDate?: string;
            settings?: components["schemas"]["VideoSettingsOutputModel"][];
            tags?: components["schemas"]["TagOutputModel"][];
            reactions?: components["schemas"]["ReactionOutputModel"][];
            comments?: components["schemas"]["CommentForStudentModel"][];
            mdxNotes: components["schemas"]["AdminMdxNoteResponseDto"][];
            slug: string | null;
            images: components["schemas"]["ImageDto"][];
            seoDescription: string | null;
        };
        UpdateVideoSettingsDto: {
            playlistId: string;
            /** @description Deprecated */
            courseId?: number;
            accessLevel: number;
            forLesson: number;
            minStudentStartCourseDate: number;
            maxStudentStartCourseDate: number;
            id?: string;
        };
        UpdateVideoTagDto: {
            text: string;
            id: string;
        };
        UpdateVideoHostingDto: {
            provider: Record<string, never>;
            locale: string;
            isPrimary: boolean;
            hostingId?: string;
            hostingHash?: string;
            url?: string;
            metadata?: Record<string, never>;
            /** @description Если id передан — обновление существующего, иначе — создание нового */
            id?: string;
        };
        UpdateVideoLocaleDto: {
            locale: string;
            name: string;
            description?: string;
            seoDescription?: string;
            /** @description Если id передан — обновление существующего, иначе — создание нового */
            id?: string;
        };
        UpdateVideoRequestPayload: {
            name: string;
            description?: string;
            hosting: string;
            hostingId: string;
            hostingHash: string;
            code?: string;
            mentor?: string;
            mentorId?: number;
            startDate?: string;
            settings: components["schemas"]["UpdateVideoSettingsDto"][];
            tags: components["schemas"]["UpdateVideoTagDto"][];
            url?: string;
            /** @enum {string} */
            publicVisibility?: VideoOutputModelPublicVisibility;
            /** @description slug should not be cuid */
            slug?: string;
            seoDescription?: string;
            hostings?: components["schemas"]["UpdateVideoHostingDto"][];
            locales?: components["schemas"]["UpdateVideoLocaleDto"][];
        };
        VideoOrderInputModel: {
            playlistId: string;
            videoId: string;
            /** @deprecated */
            courseId?: number;
            order: number;
        };
        VideoPlaylistInfo: {
            playlistId: string;
            playlistSlug: string | null;
            playlistName: string;
            courseId: number;
            forLesson: number;
            order: number;
        };
        GetRecentVideosPublicQueryItemOutput: {
            id: string;
            name: string;
            mentor: string;
            startDate: string;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            slug: string | null;
            /** Format: date-time */
            created: string;
            /** Format: date-time */
            updated: string;
            images: components["schemas"]["ImageDto"][];
            /**
             * @description Список плейлистов, к которым принадлежит это видео
             *     (отфильтровано по курсу, если courseId был передан)
             */
            playlistsInfo: components["schemas"]["VideoPlaylistInfo"][];
        };
        GetRecentVideosPublicQueryOutput: {
            items: components["schemas"]["GetRecentVideosPublicQueryItemOutput"][];
            totalCount: number;
        };
        VideoImageResponseDto: {
            /**
             * @description Type of video image (ORIGINAL | MEDIUM | THUMBNAIL)
             * @example ORIGINAL
             */
            type: components["schemas"]["ImageType"];
            width: number;
            height: number;
            fileSize: number;
            url: string;
        };
        ReactionSummaryResponseDto: {
            /** @enum {string} */
            reaction: PathsApiAdminVideosGetParametersQuerySortByReaction;
            count: number;
            reactedByMe: boolean;
        };
        PreviewMdxNoteInfoOutput: {
            /** @description Preview всегда публичный, поэтому noteId не может быть null */
            noteId: string;
        };
        MainMdxNoteInfoOutput: {
            /** @description null если нет доступа у текущего пользователя */
            noteId: string | null;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            /**
             * @description enum которой показывает какой тип ошибки доступа при попытке запросить данные о конспекте
             *     no-access значит данному пользователю конспект недоступен
             *     internal-error значит во время проверки доступа произошла ошибка и надо попробовать еще раз
             * @enum {string|null}
             */
            publicVisibilityErrorStatus: GetPlaylistVideosPublicItemResponseDtoPublicVisibilityErrorStatus;
        };
        MdxNoteSummaryPublicOutput: {
            preview: components["schemas"]["PreviewMdxNoteInfoOutput"] | null;
            main: components["schemas"]["MainMdxNoteInfoOutput"] | null;
        };
        VideoPublicResponseDto: {
            /**
             * @description Хостинги (плееры) для локали пользователя. Primary первым, далее альтернативные.
             *     Фронт может предложить переключение между плеерами.
             *     Пусто если нет доступа или нет хостингов для подходящей локали.
             */
            hostings: Record<string, never>[];
            /** @description Resolved images for the video (stored in internal storage) */
            images: components["schemas"]["VideoImageResponseDto"][];
            /** @description Связанные сущности */
            reactions: components["schemas"]["ReactionSummaryResponseDto"][];
            /** @description Основные поля видео */
            id: string;
            name: string;
            slug: string | null;
            description: string;
            hosting: string;
            hostingId: string;
            hostingHash: string;
            url: string;
            mentor: string;
            startDate: string;
            isMentor: boolean;
            /**
             * @description Indicates whether an item has been viewed or not.
             *     This variable can take a boolean value (`true` if viewed, `false` if not viewed)
             *     or `null` if the viewed status is unknown (for unauthenticated users).
             */
            viewed: boolean | null;
            /**
             * @description Сводка по MDX-конспектам для видео.
             *     Поля:
             *     - preview: информация по PREVIEW-конспекту или null, если его нет в базе
             *     - main: информация по MAIN-конспекту или null, если его нет в базе
             */
            mdxNoteSummary: components["schemas"]["MdxNoteSummaryPublicOutput"];
            /**
             * @description enum которой показывает какой тип ошибки доступа при попытке запросить видео
             *     no-access значит данному пользователю это видео недоступно
             *     internal-error значит во время проверки доступа произошла ошибка и надо попробовать еще раз
             * @enum {string|null}
             */
            publicVisibilityErrorStatus: GetPlaylistVideosPublicItemResponseDtoPublicVisibilityErrorStatus;
            /**
             * @description Ограничение по прогрессу (уровень, пейс). Отдельно от видимости
             * @enum {string|null}
             */
            availabilityError: GetPlaylistVideosPublicItemResponseDtoAvailabilityError;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
            seoDescription: string | null;
            /**
             * @deprecated
             * @description Order of the video in a playlist.
             *     - If playlistIdOrSlug is provided: returns order in that playlist or null if video is not in it
             *     - If not provided and video is in exactly one playlist: returns that playlist's order
             *     - If not provided and video is in multiple playlists: returns null
             *     - If video is not in any playlist: returns null
             */
            orderInPlaylist: number | null;
            /**
             * @description Lesson number for the video in a playlist.
             *     - If playlistIdOrSlug is provided: returns forLesson in that playlist or null if video is not in it
             *     - If not provided and video is in exactly one playlist: returns that playlist's forLesson
             *     - If not provided and video is in multiple playlists: returns null
             *     - If video is not in any playlist: returns null
             *     - Используется для соотношения видео в плейлисте и квиза для плейлиста.
             *     Чтобы подтянуть результаты по этому квизу для этого видео
             */
            forLessonInPlaylist: number | null;
            /**
             * @description Есть ли контент (тексты + хостинг) для текущей локали пользователя.
             *     false — видео не локализовано для данного языка, фронт показывает заглушку.
             */
            localeAvailable: boolean;
        };
        GetVideoResponseFriendDto: {
            id: string;
            name: string;
            slug: string | null;
            description: string;
            images: components["schemas"]["ImageDto"][];
            playlistTitle: string;
        };
        AddReactionRequestPayload: {
            /** @enum {string} */
            reaction: PathsApiAdminVideosGetParametersQuerySortByReaction;
        };
        ReactionResponseDto: {
            /** @enum {string} */
            reaction: PathsApiAdminVideosGetParametersQuerySortByReaction;
            id: string;
            studentId: number;
        };
        AddReactionResponseDto: {
            data: components["schemas"]["ReactionResponseDto"];
        };
        AdminCommentOutputModel: {
            id: string;
            studentId: number;
            text: string;
            /** Format: date-time */
            created: string;
            /** Format: date-time */
            updated: string;
            avatar: string;
            firstName: string;
            lastName: string;
            videoName: string;
            videoAuthor: string;
            videoAuthorId: number;
            courseIds: number[];
        };
        CommentsOutputModel: {
            comments: components["schemas"]["AdminCommentOutputModel"][];
            totalCount: number;
        };
        LikesSummaryQueryOutput: {
            likeCount: number;
            /** @enum {string} */
            myStatus: LikesSummaryQueryOutputMyStatus;
        };
        CommentItemResponseDto: {
            id: string;
            /** Format: date-time */
            created: string;
            /** Format: date-time */
            updated: string;
            text: string;
            studentId: number;
            firstName: string;
            lastName: string;
            userLogin: string;
            avatar: string | null;
            likesSummary: components["schemas"]["LikesSummaryQueryOutput"];
        };
        GetVideoCommentsResponseDto: {
            items: components["schemas"]["CommentItemResponseDto"][];
            totalCount: number;
        };
        AddCommentRequestPayload: {
            text: string;
        };
        GetCommentByIdResponseDto: {
            id: string;
            /** Format: date-time */
            created: string;
            /** Format: date-time */
            updated: string;
            text: string;
            studentId: number;
            firstName: string;
            lastName: string;
            userLogin: string;
            avatar: string | null;
            likesSummary: components["schemas"]["LikesSummaryQueryOutput"];
        };
        ViewInputModel: {
            /** @example clu37c4pd0000s7dm8n6f6x1y */
            videoId: string;
        };
        MdxTreeNodeOutput: {
            name: string;
            path: string;
            /** @enum {string} */
            type: MdxTreeNodeOutputType;
            children?: components["schemas"]["MdxTreeNodeOutput"][];
        };
        GetMdxTreeFilesResponseDto: {
            /** @enum {string} */
            type: MdxTreeNodeOutputType;
            /** @description Дочерние файлы/папки (только для directory) */
            children?: components["schemas"]["MdxTreeNodeOutput"][];
            name: string;
            path: string;
        };
        AddMdxNoteRequestPayload: {
            /**
             * @description Should end with *.json
             * @example frontend/example.json
             */
            mdxFilePath: string;
            /**
             * @description must be provided if NoteType.MAIN and must NOT be provided if NoteType.PREVIEW
             * @enum {string}
             */
            publicVisibility?: VideoOutputModelPublicVisibility;
            /** @enum {string} */
            type: PathsApiAdminVideosVideoIdMdxNotesDeleteParametersQueryNoteType;
        };
        UpdateMainMdxNoteRequestPayload: {
            /**
             * @description Should end with *.json
             * @example frontend/example.json
             */
            mdxFilePath: string;
            /** @enum {string} */
            publicVisibility: VideoOutputModelPublicVisibility;
        };
        UpdateMdxNotePreviewRequestPayload: {
            /**
             * @description Should end with *.json
             * @example frontend/example.json
             */
            mdxFilePath: string;
        };
        TocNodeDto: {
            /**
             * @description Тип узла
             * @enum {string}
             */
            type: TocNodeDtoType;
            /** @description Признак упорядоченного списка (только для type="list") */
            ordered?: boolean;
            /** @description Признак того, что узел «разнесён» (spread) (для list/listItem) */
            spread?: boolean;
            /** @description Заголовок ссылки (для type="link") */
            title?: string | null;
            /** @description URL-ссылка (для type="link") */
            url?: string;
            /** @description Текстовое содержимое (для type="text") */
            value?: string;
            /** @description Дочерние узлы */
            children?: components["schemas"]["TocNodeDto"][];
        };
        TocDto: {
            /** @description Дерево заголовков/ссылок */
            map: components["schemas"]["TocNodeDto"];
        };
        MdxParsedResponseDto: {
            /** @description Скомпилированный JS-код MDX */
            code: string;
            /** @description Список ошибок при бандлинге MDX */
            errors: Record<string, never>[];
            /** @description Frontmatter (метаданные) MDX-файла */
            frontmatter: Record<string, never>;
            /** @description Table of Contents */
            toc: components["schemas"]["TocDto"];
        };
        FriendUserCourseViewProjection: {
            courseId: string;
            videosViewedCount: number;
        };
        GetUserViewsByCourseQueryOutput: {
            videos: components["schemas"]["FriendUserCourseViewProjection"][];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type SchemaPlaylistSettingsOutputModel = components['schemas']['PlaylistSettingsOutputModel'];
export type SchemaImageDto = components['schemas']['ImageDto'];
export type SchemaPlaylistOutputModel = components['schemas']['PlaylistOutputModel'];
export type SchemaAdminInfoDto = components['schemas']['AdminInfoDto'];
export type SchemaPlaylistsOutputModel = components['schemas']['PlaylistsOutputModel'];
export type SchemaPlaylistSettingsInputModel = components['schemas']['PlaylistSettingsInputModel'];
export type SchemaPlaylistInputModel = components['schemas']['PlaylistInputModel'];
export type SchemaCreateResponseCommonDto = components['schemas']['CreateResponseCommonDto'];
export type SchemaSettingsAddDaysInputModel = components['schemas']['SettingsAddDaysInputModel'];
export type SchemaPlaylistSettingsUpdateModel = components['schemas']['PlaylistSettingsUpdateModel'];
export type SchemaPlaylistUpdateModel = components['schemas']['PlaylistUpdateModel'];
export type SchemaVideoForStudentInPlaylistModel = components['schemas']['VideoForStudentInPlaylistModel'];
export type SchemaPlaylistForStudentModel = components['schemas']['PlaylistForStudentModel'];
export type SchemaPlaylistsForStudentModel = components['schemas']['PlaylistsForStudentModel'];
export type SchemaVideoSettingsOutputModel = components['schemas']['VideoSettingsOutputModel'];
export type SchemaTagOutputModel = components['schemas']['TagOutputModel'];
export type SchemaReactionOutputModel = components['schemas']['ReactionOutputModel'];
export type SchemaVideoOutputModel = components['schemas']['VideoOutputModel'];
export type SchemaVideosOutputModel = components['schemas']['VideosOutputModel'];
export type SchemaPlaylistVideoImageResponseDto = components['schemas']['PlaylistVideoImageResponseDto'];
export type SchemaGetPlaylistVideosPublicItemResponseDto = components['schemas']['GetPlaylistVideosPublicItemResponseDto'];
export type SchemaPlaylistCoverImageResponseDto = components['schemas']['PlaylistCoverImageResponseDto'];
export type SchemaGetPlaylistVideosPublicResponseDto = components['schemas']['GetPlaylistVideosPublicResponseDto'];
export type SchemaPlaylistImageResponseDto = components['schemas']['PlaylistImageResponseDto'];
export type SchemaGetPlaylistsPublicItemResponseDto = components['schemas']['GetPlaylistsPublicItemResponseDto'];
export type SchemaGetPlaylistsPublicResponseDto = components['schemas']['GetPlaylistsPublicResponseDto'];
export type SchemaGetAdminVideoSettingQueryOutput = components['schemas']['GetAdminVideoSettingQueryOutput'];
export type SchemaGetAdminVideoTagQueryOutput = components['schemas']['GetAdminVideoTagQueryOutput'];
export type SchemaGetAdminVideoHostingQueryOutput = components['schemas']['GetAdminVideoHostingQueryOutput'];
export type SchemaGetAdminVideoLocaleQueryOutput = components['schemas']['GetAdminVideoLocaleQueryOutput'];
export type SchemaGetAdminVideosQueryItemOutput = components['schemas']['GetAdminVideosQueryItemOutput'];
export type SchemaGetAdminVideosResponseDto = components['schemas']['GetAdminVideosResponseDto'];
export type SchemaCreateVideoSettingsDto = components['schemas']['CreateVideoSettingsDto'];
export type SchemaCreateVideoTagDto = components['schemas']['CreateVideoTagDto'];
export type SchemaCreateVideoHostingDto = components['schemas']['CreateVideoHostingDto'];
export type SchemaCreateVideoLocaleDto = components['schemas']['CreateVideoLocaleDto'];
export type SchemaAddVideoRequestPayload = components['schemas']['AddVideoRequestPayload'];
export type SchemaCommentForStudentModel = components['schemas']['CommentForStudentModel'];
export type SchemaAdminMdxNoteResponseDto = components['schemas']['AdminMdxNoteResponseDto'];
export type SchemaAdminVideoOutputModel = components['schemas']['AdminVideoOutputModel'];
export type SchemaUpdateVideoSettingsDto = components['schemas']['UpdateVideoSettingsDto'];
export type SchemaUpdateVideoTagDto = components['schemas']['UpdateVideoTagDto'];
export type SchemaUpdateVideoHostingDto = components['schemas']['UpdateVideoHostingDto'];
export type SchemaUpdateVideoLocaleDto = components['schemas']['UpdateVideoLocaleDto'];
export type SchemaUpdateVideoRequestPayload = components['schemas']['UpdateVideoRequestPayload'];
export type SchemaVideoOrderInputModel = components['schemas']['VideoOrderInputModel'];
export type SchemaVideoPlaylistInfo = components['schemas']['VideoPlaylistInfo'];
export type SchemaGetRecentVideosPublicQueryItemOutput = components['schemas']['GetRecentVideosPublicQueryItemOutput'];
export type SchemaGetRecentVideosPublicQueryOutput = components['schemas']['GetRecentVideosPublicQueryOutput'];
export type SchemaVideoImageResponseDto = components['schemas']['VideoImageResponseDto'];
export type SchemaReactionSummaryResponseDto = components['schemas']['ReactionSummaryResponseDto'];
export type SchemaPreviewMdxNoteInfoOutput = components['schemas']['PreviewMdxNoteInfoOutput'];
export type SchemaMainMdxNoteInfoOutput = components['schemas']['MainMdxNoteInfoOutput'];
export type SchemaMdxNoteSummaryPublicOutput = components['schemas']['MdxNoteSummaryPublicOutput'];
export type SchemaVideoPublicResponseDto = components['schemas']['VideoPublicResponseDto'];
export type SchemaGetVideoResponseFriendDto = components['schemas']['GetVideoResponseFriendDto'];
export type SchemaAddReactionRequestPayload = components['schemas']['AddReactionRequestPayload'];
export type SchemaReactionResponseDto = components['schemas']['ReactionResponseDto'];
export type SchemaAddReactionResponseDto = components['schemas']['AddReactionResponseDto'];
export type SchemaAdminCommentOutputModel = components['schemas']['AdminCommentOutputModel'];
export type SchemaCommentsOutputModel = components['schemas']['CommentsOutputModel'];
export type SchemaLikesSummaryQueryOutput = components['schemas']['LikesSummaryQueryOutput'];
export type SchemaCommentItemResponseDto = components['schemas']['CommentItemResponseDto'];
export type SchemaGetVideoCommentsResponseDto = components['schemas']['GetVideoCommentsResponseDto'];
export type SchemaAddCommentRequestPayload = components['schemas']['AddCommentRequestPayload'];
export type SchemaGetCommentByIdResponseDto = components['schemas']['GetCommentByIdResponseDto'];
export type SchemaViewInputModel = components['schemas']['ViewInputModel'];
export type SchemaMdxTreeNodeOutput = components['schemas']['MdxTreeNodeOutput'];
export type SchemaGetMdxTreeFilesResponseDto = components['schemas']['GetMdxTreeFilesResponseDto'];
export type SchemaAddMdxNoteRequestPayload = components['schemas']['AddMdxNoteRequestPayload'];
export type SchemaUpdateMainMdxNoteRequestPayload = components['schemas']['UpdateMainMdxNoteRequestPayload'];
export type SchemaUpdateMdxNotePreviewRequestPayload = components['schemas']['UpdateMdxNotePreviewRequestPayload'];
export type SchemaTocNodeDto = components['schemas']['TocNodeDto'];
export type SchemaTocDto = components['schemas']['TocDto'];
export type SchemaMdxParsedResponseDto = components['schemas']['MdxParsedResponseDto'];
export type SchemaFriendUserCourseViewProjection = components['schemas']['FriendUserCourseViewProjection'];
export type SchemaGetUserViewsByCourseQueryOutput = components['schemas']['GetUserViewsByCourseQueryOutput'];
export type $defs = Record<string, never>;
export interface operations {
    AppController_getHello: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_dropTestData: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_getAll: {
        parameters: {
            query?: {
                search?: string;
                courseId?: string;
                /** @description default = 50, > 0 */
                pageSize?: number;
                /** @description default = 1, > 0 */
                page?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaylistsOutputModel"];
                };
            };
        };
    };
    PlaylistsAdminController_add: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaylistInputModel"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateResponseCommonDto"];
                };
            };
        };
    };
    PlaylistsAdminController_addDays: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SettingsAddDaysInputModel"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_getById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaylistOutputModel"];
                };
            };
        };
    };
    PlaylistsAdminController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlaylistUpdateModel"];
            };
        };
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_del: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_upsertImage: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description Playlist cover image. Max size 3 MB, up to 1920x1080.
                     */
                    image: string;
                };
            };
        };
        responses: {
            /** @description Playlist image successfully replaced. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsAdminController_deleteImage: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Playlist image successfully deleted. */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    PlaylistsStudentController_getPlaylists: {
        parameters: {
            query?: {
                /** @description default = false */
                onlyNotViewed?: boolean;
                /** @description default = false */
                withoutVideos?: boolean;
            };
            header?: {
                courseid?: string;
                accesslevel?: string;
                startdate?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaylistsForStudentModel"];
                };
            };
        };
    };
    PlaylistsStudentController_getVideos: {
        parameters: {
            query?: {
                name?: string;
                /** @description default = 50 */
                pageSize?: number;
                /** @description default = 1 */
                page?: number;
            };
            header?: {
                courseid?: string;
                accesslevel?: string;
                startdate?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VideosOutputModel"];
                };
            };
        };
    };
    PlaylistsStudentController_getVideosForPlaylist: {
        parameters: {
            query?: {
                /** @description default = 150 */
                pageSize?: number;
                /** @description default = 1 */
                page?: number;
                name?: unknown;
            };
            header?: {
                courseid?: string;
                accesslevel?: string;
                startdate?: string;
            };
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VideosOutputModel"];
                };
            };
        };
    };
    FriendController_video: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaylistsForStudentModel"];
                };
            };
        };
    };
    FriendController_getPlaylistCourseIds: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playlistId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    FriendController_notViewed: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlaylistsForStudentModel"];
                };
            };
        };
    };
    PlaylistsPublicController_getPublicVideosByPlaylistId: {
        parameters: {
            query: {
                page: number;
                pageSize: number;
            };
            header?: never;
            path: {
                idOrSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPlaylistVideosPublicResponseDto"];
                };
            };
        };
    };
    PlaylistsPublicController_getPublicPlaylists: {
        parameters: {
            query: {
                courseId: number;
                sortBy: PathsApiPlaylistsGetParametersQuerySortBy;
                sortDirection: PathsApiPlaylistsGetParametersQuerySortDirection;
                page: number;
                pageSize: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetPlaylistsPublicResponseDto"];
                };
            };
        };
    };
    VideosAdminController_dropTestData: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_getAll: {
        parameters: {
            query: {
                search?: string;
                playlist?: string;
                course?: number;
                direction: PathsApiPlaylistsGetParametersQuerySortDirection;
                sortByReaction?: PathsApiAdminVideosGetParametersQuerySortByReaction;
                page: number;
                pageSize: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetAdminVideosResponseDto"];
                };
            };
        };
    };
    VideosAdminController_add: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddVideoRequestPayload"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CreateResponseCommonDto"];
                };
            };
        };
    };
    VideosAdminController_getByPlaylist: {
        parameters: {
            query?: {
                search?: string;
                /** @description default = 50 */
                pageSize?: number;
                /** @description default = 1 */
                page?: number;
            };
            header?: never;
            path: {
                id: unknown;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VideosOutputModel"];
                };
            };
        };
    };
    VideosAdminController_addDays: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SettingsAddDaysInputModel"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_getById: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdminVideoOutputModel"];
                };
            };
        };
    };
    VideosAdminController_update: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateVideoRequestPayload"];
            };
        };
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_del: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    VideosAdminController_replaceImages: {
        parameters: {
            query?: {
                /** @description Locale to sync images for (e.g. "ru", "en"). If omitted — syncs all locales. */
                locale?: string;
            };
            header?: never;
            path: {
                /** @description Video ID */
                id: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Images have been replaced successfully */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_sortAll: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                x: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_sort: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                pl: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_order: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playlistId: string;
                videoId: string;
                order: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosAdminController_orderNew: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoOrderInputModel"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    VideosPublicController_getRecentVideos: {
        parameters: {
            query: {
                /**
                 * @description Фильтр по ID курса (опционально)
                 *     Если указан, возвращает только видео из плейлистов этого курса
                 */
                courseId?: number;
                page: number;
                pageSize: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetRecentVideosPublicQueryOutput"];
                };
            };
        };
    };
    VideosPublicController_getVideo: {
        parameters: {
            query: {
                playlistIdOrSlug: string;
            };
            header?: {
                startdate?: string;
                accesslevel?: string;
                courseid?: string;
            };
            path: {
                idOrSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["VideoPublicResponseDto"];
                };
            };
            /** @description not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    FriendVideoController_getVideo: {
        parameters: {
            query: {
                playlistSlug: string;
            };
            header?: never;
            path: {
                videoSlug: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetVideoResponseFriendDto"];
                };
            };
        };
    };
    MigrateHostingsController_migrateHostings: {
        parameters: {
            query?: {
                /** @description Batch size (default 100) */
                batch?: string;
            };
            header?: never;
            path: {
                key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Count of migrated records */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MigrateHostingsController_migrateLocales: {
        parameters: {
            query?: {
                /** @description Batch size (default 100) */
                batch?: string;
            };
            header?: never;
            path: {
                key: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Count of migrated records */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ReactionsController_add: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                videoId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddReactionRequestPayload"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AddReactionResponseDto"];
                };
            };
        };
    };
    VideoReactionsController_removeReaction: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Video ID */
                videoId: string;
                /** @description Reaction type */
                type: PathsApiAdminVideosGetParametersQuerySortByReaction;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Reaction has been removed (or did not exist) */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CommentsController_del: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                commentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CommentsController_addLike: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                commentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CommentsController_deleteLike: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                commentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AdminCommentsController_getAll: {
        parameters: {
            query?: {
                courseId?: number;
                videoAuthor?: number;
                search?: string;
                /** @description default = 50 */
                pageSize?: number;
                /** @description default = 1 */
                page?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CommentsOutputModel"];
                };
            };
        };
    };
    AdminCommentsController_fix: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    AdminCommentsController_del: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                commentId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CommentsVideoController_getByVideo: {
        parameters: {
            query: {
                pageSize: number;
                cursorId?: string;
                sortBy: PathsApiVideosIdOrSlugVideoCommentsGetParametersQuerySortBy;
                orderBy: PathsApiPlaylistsGetParametersQuerySortDirection;
            };
            header?: never;
            path: {
                idOrSlugVideo: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetVideoCommentsResponseDto"];
                };
            };
        };
    };
    CommentsVideoController_add: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                videoIdOrSlug: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddCommentRequestPayload"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetCommentByIdResponseDto"];
                };
            };
        };
    };
    ViewController_add: {
        parameters: {
            query?: {
                /** @description Optional playlist identifier or slug to resolve context */
                playlistIdOrSlug?: string;
            };
            header?: never;
            path: {
                /**
                 * @description Target video identifier
                 * @example clu37c4pd0000s7dm8n6f6x1y
                 */
                videoId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Viewed state stored (idempotent) */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ViewController_delete: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Target video identifier
                 * @example clu37c4pd0000s7dm8n6f6x1y
                 */
                videoId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Viewed mark cleared or already absent */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DeprecatedViewController_add: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ViewInputModel"];
            };
        };
        responses: {
            /** @description Viewed state toggled (deprecated endpoint) */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxFilesAdminController_getMdxFilesTree: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description MDX-files tree */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetMdxTreeFilesResponseDto"][];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxFilesAdminController_getMdxFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description file path like 'md-lesson-backend/sprint-03/lesson-11/01-mongoose-schema.json' */
                mdxpath: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description json file */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxNotesAdminController_addMdxNoteForVideo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                videoId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AddMdxNoteRequestPayload"];
            };
        };
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description incorrect input */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxNotesAdminController_deleteMdxNoteById: {
        parameters: {
            query: {
                noteType: PathsApiAdminVideosVideoIdMdxNotesDeleteParametersQueryNoteType;
            };
            header?: never;
            path: {
                videoId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description video not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxNotesAdminController_updateMdxNoteForVideo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                videoId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMainMdxNoteRequestPayload"];
            };
        };
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description incorrect input */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxNotesAdminController_updateMdxNotePreviewForVideo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                videoId: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateMdxNotePreviewRequestPayload"];
            };
        };
        responses: {
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description incorrect input */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    MdxNotesPublicController_getVideoMdxNoteFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                noteId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description json file stream, */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["MdxParsedResponseDto"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    FriendUserStatisticController_getViewsByCourse: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetUserViewsByCourseQueryOutput"];
                };
            };
        };
    };
    DynamicMetricsController_getMetrics: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    CasbinController_generateActions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    HealthController_healthCheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description The Health Check is successful */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example ok */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /** @example {} */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
            /** @description The Health Check is not successful */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example error */
                        status?: string;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       }
                         *     }
                         */
                        info?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        error?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        } | null;
                        /**
                         * @example {
                         *       "database": {
                         *         "status": "up"
                         *       },
                         *       "redis": {
                         *         "status": "down",
                         *         "message": "Could not connect"
                         *       }
                         *     }
                         */
                        details?: {
                            [key: string]: {
                                status: string;
                            } & {
                                [key: string]: unknown;
                            };
                        };
                    };
                };
            };
        };
    };
}
export enum PathsApiPlaylistsGetParametersQuerySortBy {
    name = "name",
    created = "created"
}
export enum PathsApiPlaylistsGetParametersQuerySortDirection {
    asc = "asc",
    desc = "desc"
}
export enum PathsApiAdminVideosGetParametersQuerySortByReaction {
    improved_understanding = "improved_understanding",
    hard_understanding = "hard_understanding",
    normal = "normal",
    fire_presentation = "fire_presentation",
    super_content = "super_content",
    obsolete = "obsolete",
    failed_presentation = "failed_presentation",
    all_understanding = "all_understanding",
    nothing_new = "nothing_new"
}
export enum PathsApiVideosIdOrSlugVideoCommentsGetParametersQuerySortBy {
    created = "created",
    updated = "updated"
}
export enum PathsApiAdminVideosVideoIdMdxNotesDeleteParametersQueryNoteType {
    PREVIEW = "PREVIEW",
    MAIN = "MAIN"
}
export enum VideoOutputModelPublicVisibility {
    NONE = "NONE",
    PUBLIC = "PUBLIC",
    REGISTERED = "REGISTERED",
    SUBSCRIBER = "SUBSCRIBER"
}
export enum ImageType {
    ORIGINAL = "ORIGINAL",
    THUMBNAIL = "THUMBNAIL",
    MEDIUM = "MEDIUM"
}
export enum GetPlaylistVideosPublicItemResponseDtoPublicVisibilityErrorStatus {
    no_access = "no-access",
    internal_error = "internal-error",
    requires_auth = "requires-auth"
}
export enum GetPlaylistVideosPublicItemResponseDtoAvailabilityError {
    locked_by_level = "locked-by-level",
    internal_error = "internal-error"
}
export enum GetAdminVideoHostingQueryOutputProvider {
    YOUTUBE = "YOUTUBE",
    VK = "VK",
    KINESCOPE = "KINESCOPE",
    VIMEO = "VIMEO"
}
export enum LikesSummaryQueryOutputMyStatus {
    like = "like",
    none = "none"
}
export enum MdxTreeNodeOutputType {
    file = "file",
    directory = "directory"
}
export enum TocNodeDtoType {
    list = "list",
    listItem = "listItem",
    paragraph = "paragraph",
    link = "link",
    text = "text"
}
